/* eslint-disable */
/* eslint-disable @typescript-eslint/no-empty-interface, class-methods-use-this, arrow-body-style */
/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import withRouter from 'src/hooks/withRouter';
import {
  CandidateResumeProps,
  CandidateResumeState,
  CandidateResumeViewRendererProps,
  PopupProps,
} from './types';
import ViewRenderer from './views';
import { AppDispatch, AppRootState } from 'src/store';
import { FileValueType } from 'src/components/elements/File';
import { confirmWrapper } from 'src/components/Dialog';
import PlayServiceRequests from 'src/network/playServices';
import API from '../../network';
import { fetchCandidateInfo } from 'src/store/talentPoolSelectedProfile';

type CandidateResumePropsWithRedux = CandidateResumeProps & ConnectedProps<typeof connector>;

class CandidateResume extends Component<CandidateResumePropsWithRedux, CandidateResumeState> {
  constructor(props: CandidateResumePropsWithRedux) {
    super(props);
    this.state = {
      loading: false,
      profileInfo: undefined,
      resumeDetails: {
        fileURL: '',
        presignedUrl: '',
        htmlCode: '',
      }
    };
  }

  static getDerivedStateFromProps(newData: CandidateResumePropsWithRedux, prevData: CandidateResumeState) {
    const { reduxProps } = newData;
    const { selectedTalentPoolProfile } = reduxProps;
    const { candidateInfo } = selectedTalentPoolProfile;
    if (prevData.profileInfo !== candidateInfo) {
      return {
        profileInfo: candidateInfo,
      }
    }
    return null;
  }

  componentDidMount() {
    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    this.setState({ profileInfo: selectedTalentPoolProfile?.candidateInfo });
    this.fetchCandidateResumeDetails();
  }

  fetchCandidateResumeDetails = async() => {
    try{
      const { router } = this.props;
      const candidateId = router.params.candidateId;
      if(candidateId){
        const { data } = await API.getInstance().fetchCandidateResumeDetails(candidateId);
        this.setState({
          resumeDetails : {
            fileURL: data?.fileURL || '',
            presignedUrl: data?.presignedUrl || '',
            htmlCode: data?.resumeHtmlUrl || '',
          }
        })
      }
    }catch(error: any){
      await confirmWrapper(`Failed to get resume details: ${error?.message || ''}`, {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  }

  uploadResume = async (parserResponse: any) => {
    const { dispatch, router } = this.props;
    const candidateId = router.params.candidateId;
    const { resumeDetails, profileInfo } = this.state;
    const updateTitle = resumeDetails?.fileURL ? 'uploaded' : 'updated';
    try {
      const { s3DownloadLink, s3HtmlLink } = parserResponse;
      const request = {
        fileUrl: s3DownloadLink,
        htmlURL: s3HtmlLink,
        candidateId: profileInfo?.candidateId || 0,
      };
      await API.getInstance().updateResume(request);
      await confirmWrapper(`Candidate resume ${updateTitle} successfully`, {
        variant: 'success',
        autoClose: true,
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
      await dispatch(fetchCandidateInfo(candidateId));
    } catch (error: any) {
      await confirmWrapper(`Failed to ${updateTitle} resume: ${error?.message || ''}`, {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  }

  handleResumeUpload = async (file: FileValueType) => {
    if(!file) return;
    const { resumeDetails, profileInfo } = this.state;
    const updateTitle = resumeDetails?.fileURL ? 'upload' : 'update';
    const formData = new FormData();
    formData.append('file', file ? file as File : '');
    formData.append('s3FolderName', 'PANNA');
    formData.append('userId', profileInfo?.candidateId?.toString() || '');
    formData.append('fileExtension', (file as File)?.type || '');

    const fileName = (file as File)?.name || '';

    try {
      this.setState({ loading: true });
      const response = await PlayServiceRequests.getInstance().resumeParser(formData);
      const { email } = response;
      if(email === profileInfo?.emailAddress){
        const confirmation = await confirmWrapper(
          `Are you sure you want to ${updateTitle} the resume?`,
          {
            variant: 'warning',
            primaryBtnLabel: 'Proceed',
            secondaryBtnLabel: 'Cancel',
          },
        );
        if(confirmation){
          await this.uploadResume(response);
        }
      }
      else{
        confirmWrapper(`Mail id in resume is not matching with the mail id in profile. Please select a valid resume`, {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      }
    } catch (error: any) {
      confirmWrapper(`An error occurred: ${error?.message || 'Unknown error'}`, {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  getProps = (): CandidateResumeViewRendererProps => {
    const {
      loading,
      profileInfo,
      resumeDetails
    } = this.state;

    return {
      loading,
      profileInfo,
      resumeDetails,
      handleResumeUpload: this.handleResumeUpload,
    };
  };

  render() {
    const viewProps: CandidateResumeViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

const mapStateToProps = (reduxProps: AppRootState) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  dispatch,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(withRouter(CandidateResume));